import { createBoundedUseStore } from '../util';
import { createCrossFrameStore } from '../util/createCrossFrameStore';

import { createAiAgentSlice, type AiAgentSlice } from './Agent';

export type AIStore = AiAgentSlice;

const initialState = {};

/**
 * Vanilla store that contains global state for our AI related features.
 * This store can be accessed and used anywhere. React components
 * should call `useAIStore()` instead.
 * @example
 * import { aiStore } from '@core/store';
 *
 * const checkpoints = aiStore.getState().agent.checkpoints;
 */
export const aiStore = createCrossFrameStore<AIStore>('AIStore', (set, get, ...props) => {
  return {
    ...createAiAgentSlice(set, get, ...props),
    ...initialState,
  };
});

/**
 * Bound react hook to access our AI store. Must be called within a React
 * component. To access the store outside of React, use `aiStore` instead.
 * @example
 * import { useAIStore } from '@core/store';
 *
 * function Component() {
 *   const checkpoints = useAIStore(s => s.agent.checkpoints);
 * }
 */
export const useAIStore = createBoundedUseStore(aiStore);
